import api from '@/shared/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import DataCacheService from '@/shared/services/DataCacheService';
import { ProfileQueryKey } from './queryKey';
export const useUpdateProfile = () => {
    const intl = useIntl();
    const queryClient = useQueryClient();
    const { mutateAsync, isLoading } = useMutation(model => api.base
        .put('/api/employee/profile', model)
        .then(res => res.data), {
        onSuccess: result => {
            if (result) {
                const dataCache = DataCacheService.getDataCache();
                if (dataCache) {
                    dataCache.employee = result;
                }
                queryClient.setQueryData([ProfileQueryKey.Profile], result);
            }
        },
        onError: apiError => {
            handleHttpError(intl)(apiError);
        },
    });
    return { updateProfile: mutateAsync, isLoading };
};
